import request from "superagent";
import _ from "lodash";
import { getAuthHeader } from "../utils/superagent";

export const RETRIEVE = "locations/RETRIEVE";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {
  locations: [],
  groups: [],
  locationMap: {},
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'locations' implicitly has an 'any' type.
const getGroups = (locations) => {
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'location' implicitly has an 'any' type.
  const mapGroups = (location) => (_.isEmpty(location.groups) ? location.name : location.groups);

  const groups = _.chain(locations).flatMap(mapGroups).uniq().value();

  return groups;
};

/**
 * Redux state management and other boilerplate code is painful to manage and hinders discoverability.
 * Redux code guidelines show this bizarre pattern with initializing function arguments
 * without a default for the action. Example:
 * https://redux.js.org/usage/structuring-reducers/initializing-state#single-simple-reducer
 * This is linted against via typical lint rules.
 * Unfortunately, redux recommends this, so we need to mark the lint rule as disabled until
 * we eliminate redux from the code base.
 * https://linear.app/clipboardhealth/issue/FEF-167/deprecate-redux
 */
// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'action' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE:
      return {
        ...state,
        locations: action.data,
        groups: getGroups(action.data),
        locationMap: _.keyBy(action.data, "_id"),
      };

    default:
      return state;
  }
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
export const getLocations = (data) => {
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'dispatch' implicitly has an 'any' type.
  return async (dispatch) => {
    return (
      request
        // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
        .get(`${global.api}/location`)
        .set(await getAuthHeader())
        .send(data)
        .then((res) => {
          dispatch({
            type: RETRIEVE,
            data: res.body,
          });
        })
    );
  };
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'locationList' implicitly has an 'any' type.
export const getLocationFromRegions = (locationList, inputRegions) => {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const locations: any[] = [];
  const regions = inputRegions || [];

  _.forEach(locationList, (location) => {
    const groups = location.groups || [];

    if (_.isEmpty(groups) && regions.includes(location.name)) {
      locations.push(location._id);
      return;
    }

    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'group' implicitly has an 'any' type.
    if (groups.find((group) => regions.includes(group))) {
      locations.push(location._id);
    }
  });

  return locations;
};
